import HomeService from "./service";

export * from "./reqres";

export default HomeService;
